import _split from 'lodash/split';
import _parseInt from 'lodash/parseInt';
import {
  WS_CONNECT,
  WS_DISCONNECT,
  WS_OPEN,
  WS_CLOSE,
  WS_JOIN_TOPIC,
  WS_LEAVE_TOPIC,
  WS_SEND_SUBSCRIPTION,
  WS_REPLY,
  WS_RECEIVED_ASYNC_RESULT,
  WS_RECEIVED_ERROR,
  WS_RECEIVED_OPERATION,
  WS_RECEIVED_SUBSCRIPTION_DATA,
} from '../constants/ActionTypes';
import {
  WS_TOPIC_PHOENIX,
  WS_TOPIC_GRAPHQL,
  WS_GRAPHQL_SUBSCRIPTIONS_REF,
} from '../constants/App';
import * as wsEvents from '../constants/WsEvents';
import logger from '../logger/logger';
import { buildGraphQLVariables } from '../utils/Tools';

/*
** From Webpack Env Config
*/
const WS_URL = __WS_URL__; // eslint-disable-line no-undef
// const WS_URL = 'ws://192.168.1.151:4000/socket/websocket'
// const WS_URL = 'wss://opac-staging.onepark.fr/socket/websocket';
// const WS_URL = 'ws://34.253.95.8';

// Phoenix messages format
// 1.0.0:
// {
//   topic,
//   event,
//   payload,
//   ref,
// }
// 2.0.0:
// [
//   ref,
//   join_ref,
//   topic,
//   event,
//   payload
// ]
const VSN_VERSION = '2.0.0';

// The web socket
let webSocket;
let intervalId;

// Message serializer
const serializeMessage = (action, event) => {
  switch (VSN_VERSION) {
    case '1.0.0':
      return JSON.stringify({
        topic: action.topic,
        ref: action.ref,
        event,
        payload: action.payload || null,
      });
    case '2.0.0':
      return JSON.stringify([
        action.ref,
        action.joinRef,
        action.topic,
        event,
        action.payload || null,
      ]);
    default:
      return null;
  }
};

// Message deserializer
const deserializeMessage = (data) => {
  switch (VSN_VERSION) {
    case '1.0.0':
      return data;
    case '2.0.0':
      return {
        ref: data[0],
        joinRef: data[1],
        topic: data[2],
        event: data[3],
        payload: data[4],
      };
    default:
      return null;
  }
};

// Handlers
const onWsOpen = (next) => () => () => {
  logger.info('WebSockets HANDLER', 'open');
  next({
    type: WS_OPEN,
  });
  // Heartbeat
  clearInterval(intervalId);
  intervalId = setInterval(() => webSocket.send(serializeMessage({ topic: WS_TOPIC_PHOENIX }, wsEvents.EVENT_PHX_HEARTBEAT)), 30000);
};

const onWsClose = (next) => () => (e) => {
  logger.warn('WebSockets HANDLER', 'close');
  clearInterval(intervalId);
  next({
    type: WS_CLOSE,
    code: e.code,
  });
};

const onWsMessage = (next) => () => (e) => {
  const message = deserializeMessage(JSON.parse(e.data));
  logger.group(`WebSockets MESSAGE ${message.event}`);
  logger.info(message);
  logger.groupEnd(`WebSockets MESSAGE ${message.event}`);
  const {
    ref, joinRef, topic, event, payload,
  } = message;
  switch (event) {
    case wsEvents.EVENT_PHX_REPLY:
      next({
        type: WS_REPLY,
        ref,
        joinRef,
        topic,
        payload,
      });
      break;
    case wsEvents.EVENT_ASYNC_RESULT:
      next({
        type: WS_RECEIVED_ASYNC_RESULT,
        id: _parseInt(_split(topic, ':')[1]),
        asyncOperation: payload.async_operation,
      });
      break;
    case wsEvents.EVENT_CREATE:
    case wsEvents.EVENT_UPDATE:
    case wsEvents.EVENT_DELETE:
    case wsEvents.EVENT_HEAD:
    case wsEvents.EVENT_INFO:
      next({
        type: WS_RECEIVED_OPERATION,
        operation: event,
        payload,
        topic,
      });
      break;
    case wsEvents.EVENT_SUBSCRIPTION_DATA:
      next({
        type: WS_RECEIVED_SUBSCRIPTION_DATA,
        data: payload.result.data,
      });
      break;
    default:
      break;
  }
};

const onWsError = (next) => () => (e) => {
  logger.error('WebSockets ERROR', e);
  next({
    type: WS_RECEIVED_ERROR,
    event: e,
  });
};

// Middleware
const webSocketService = (store) => (next) => (action) => {
  next(action);

  const onOpen = onWsOpen(next);
  const onClose = onWsClose(next);
  const onMessage = onWsMessage(next);
  const onError = onWsError(next);

  // Get OPEN state of webSocket
  const webSocketOpen = store.getState().webSocket.open;

  switch (action.type) {
    case WS_CONNECT:
      if (webSocket && webSocketOpen) {
        webSocket.close();
      }
      // Start a new connection
      webSocket = new WebSocket(`${WS_URL}?jwt=${store.getState().auth.token}&vsn=${VSN_VERSION}`);
      webSocket.onopen = onOpen();
      webSocket.onclose = onClose();
      webSocket.onmessage = onMessage();
      webSocket.onerror = onError();
      break;
    case WS_DISCONNECT:
      if (webSocket && webSocketOpen) {
        webSocket.close();
        webSocket = null;
      }
      break;
    case WS_JOIN_TOPIC:
      if (webSocket && webSocketOpen) {
        webSocket.send(serializeMessage(action, wsEvents.EVENT_PHX_JOIN));
      }
      break;
    case WS_LEAVE_TOPIC:
      if (webSocket && webSocketOpen) {
        webSocket.send(serializeMessage(action, wsEvents.EVENT_PHX_LEAVE));
      }
      break;
    case WS_SEND_SUBSCRIPTION:
      if (webSocket && webSocketOpen) {
        webSocket.send(serializeMessage({
          topic: WS_TOPIC_GRAPHQL,
          ref: WS_GRAPHQL_SUBSCRIPTIONS_REF,
          joinRef: action.joinRef,
          payload: {
            query: action.subscription,
            variables: buildGraphQLVariables(action.data),
          },
        }, wsEvents.EVENT_PHX_DOC));
      }
      break;
    default:
      break;
  }
};

export default webSocketService;



// WEBPACK FOOTER //
// ./middlewares/webSocketService.js